import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import KayttoehdotContent from '../../content/KayttoehdotContent';
import TietosuojaselosteContent from '../../content/TietosuojaselosteContent';
import MobileTermsActions from '../components/MobileTermsActions';
import {
  acceptTermsInDraft,
  clearTermsOpenedFromApplication,
  declineTermsInDraft,
  isTermsOpenedFromApplication,
  loadMobileApplicationDraft,
} from '../utils/mobileApplicationDraft';
import MobileLegalFrame from './MobileLegalFrame';

export default function MobileKayttoehdot() {
  const location = useLocation();
  const navigate = useNavigate();
  const scrollRef = useRef(null);
  const [view, setView] = useState('terms');
  const fromApplication =
    location.state?.fromApplication === true || isTermsOpenedFromApplication();

  useEffect(() => {
    scrollRef.current?.scrollTo({ top: 0, behavior: 'smooth' });
  }, [view]);

  const handleAccept = () => {
    acceptTermsInDraft();
    clearTermsOpenedFromApplication();
    navigate('/m', { state: { returnStep: 4 }, replace: true });
  };

  const handleDecline = () => {
    const draft = loadMobileApplicationDraft();
    if (draft) {
      declineTermsInDraft();
    }
    clearTermsOpenedFromApplication();
    navigate('/m', { state: { returnStep: 1 }, replace: true });
  };

  return (
    <MobileLegalFrame
      title={view === 'terms' ? 'Käyttöehdot' : 'Tietosuojaseloste'}
      scrollRef={scrollRef}
      onBack={view === 'privacy' ? () => setView('terms') : null}
      backLabel="Takaisin käyttöehtoihin"
      actions={
        fromApplication ? (
          <MobileTermsActions onAccept={handleAccept} onDecline={handleDecline} />
        ) : null
      }
    >
      {view === 'terms' ? (
        <KayttoehdotContent onOpenPrivacy={() => setView('privacy')} />
      ) : (
        <TietosuojaselosteContent />
      )}
    </MobileLegalFrame>
  );
}
